import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import '../../assets/css/style.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import RegistryTable from '../shared/RegistryTable_RT';
import RegistryMap from '../shared/RegistryMap.jsx';
import ConfirmActionModal from '../shared/ConfirmActionModal.jsx';
// import SearchBlock from '../shared/SearchBlock';

import { Redirect } from 'react-router-dom';

import * as api from '../../api/api';
import * as utils from '../../utils';

class CheckpointPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      checkpoints: [],
      isMapShow: true,
      isUserAdmin: api.isUserAdmin(),
    };

    this.handleConfirmRunImportAction =
      this.handleConfirmRunImportAction.bind(this);

    this.handleRowClick = this.handleRowClick.bind(this);

    this.handleAddAction = this.handleAddAction.bind(this);
    this.handleEditAction = this.handleEditAction.bind(this);
    this.handleConfirmDeleteAction = this.handleConfirmDeleteAction.bind(this);
    this.updateMarkers = this.updateMarkers.bind(this);
    this.processGetCheckpointsPromise =
      this.processGetCheckpointsPromise.bind(this);
    // this.handleSearchButtonClick = this.handleSearchButtonClick.bind(this);
    this.handleResetSearchClick = this.handleResetSearchClick.bind(this);

    this.tableColumns = [
      {
        Header: '_id',
        accessor: 'id',
      },
      {
        Header: '#',
        accessor: 'number',
      },
      {
        Header: 'Название',
        accessor: 'name',
      },
      {
        Header: 'Описание',
        accessor: 'description',
      },
      {
        Header: 'Широта',
        accessor: 'latitude',
      },
      {
        Header: 'Долгота',
        accessor: 'longitude',
      },
    ];

    this.checkpointMarks = [];

    this.props.updateLoader({
      loaded: false,
      message: '',
    });
  }

  componentDidMount() {
    this.processGetCheckpointsPromise(api.getCheckpoints());
  }

  updateMarkers(start, end) {
    this.setState({
      checkpointMarks: this.checkpointMarks.slice(start, end),
      markersUpdateInd: start,
      selectedObjectId: 0,
    });
  }

  processGetCheckpointsPromise(promise) {
    this.props.updateLoader({
      loaded: false,
      message: '',
    });

    api.makeRequest(promise).then(
      (response) => {
        this.checkpointMarks = response.data.data.map((item, i) => {
          return {
            id: item.id,
            title: item.name,
            coordinates: [item.latitude, item.longitude],
          };
        });

        this.setState({
          checkpoints: response.data.data.map((item, i) => {
            return {
              id: item.id,
              number: i + 1,
              name: item.name,
              description: item.description,
              latitude: utils.formatDouble(item.latitude),
              longitude: utils.formatDouble(item.longitude),
            };
          }),
        });

        this.props.updateLoader({
          loaded: true,
        });
      },
      (error) => {
        this.props.updateLoader({
          loaded: true,
          message: 'Ошибка при получении данных: ' + error,
        });
      },
    );
  }

  handleConfirmRunImportAction() {
    this.props.updateLoader({
      loaded: false,
      message: '',
    });

    api.makeRequest(api.runCheckpointsImport(true)).then(
      (response) => {
        const importStat = response.data.data;
        alert(
          `Импорт остановок выполнен. Добавлено: ${importStat.created}, изменено: ${importStat.updated}, удалено: ${importStat.deleted}`,
        );
        this.processGetCheckpointsPromise(api.getCheckpoints());
      },
      (error) => {
        this.props.updateLoader({
          loaded: true,
          message: 'Ошибка при выполнении действия: ' + error,
        });
      },
    );
  }

  handleRowClick(objectId) {
    this.setState({
      selectedObjectId: objectId,
      markersUpdateInd: objectId,
    });
  }

  handleAddAction() {
    this.setState({
      redirectUrl: '/checkpoints/0/details?return_url=/checkpoints',
    });
  }

  handleEditAction() {
    this.setState({
      redirectUrl:
        '/checkpoints/' +
        this.state.selectedObjectId +
        '/details?return_url=/checkpoints',
    });
  }

  handleConfirmDeleteAction() {
    this.props.updateLoader({
      loaded: false,
      message: '',
    });

    api.makeRequest(api.removeCheckpoint(this.state.selectedObjectId)).then(
      (response) => {
        for (let i = 0; i < this.state.checkpoints.length; i++) {
          if (
            this.state.selectedObjectId === this.state.checkpoints[i].entityId
          ) {
            let copy = this.state.checkpoints.slice();
            copy.splice(i, 1);

            this.setState({
              checkpoints: copy,
            });

            this.props.updateLoader({
              loaded: true,
              message: '',
            });
          }
        }
      },
      (error) => {
        this.props.updateLoader({
          loaded: true,
          message: 'Ошибка при выполнении действия: ' + error,
        });
      },
    );
  }

  // handleSearchButtonClick(searchValue) {
  //     this.processGetCheckpointsPromise(api.searchCheckpoints(searchValue));
  // }

  handleResetSearchClick() {
    this.processGetCheckpointsPromise(api.getCheckpoints());
  }

  render() {
    if (this.state.redirectUrl) {
      return <Redirect to={this.state.redirectUrl} />;
    }

    return (
      <div class="d-flex justify-content-between">
        <div className="flex-grow-1">
          {/* <SearchBlock
                        placeholder="Введите часть названия или описания..."
                        handleSearchButtonClick={this.handleSearchButtonClick}
                        onResetSearchClick={this.handleResetSearchClick}
                    /> */}

          <div className="mt-4">
            <RegistryTable
              columns={this.tableColumns}
              data={this.state.checkpoints}
              showActions={this.state.isUserAdmin}
              onRowClick={this.handleRowClick}
              onAddAction={this.handleAddAction}
              onEditAction={this.handleEditAction}
              onPageChange={(start, end) => this.updateMarkers(start, end)}
              customBtnGroup={
                utils.getIsViewportEqual('xs', 'sm') ? null : (
                  <div className="btn-group ml-3">
                    <button
                      className="btn btn-secondary"
                      title="Показать/скрыть карту"
                      onClick={() =>
                        this.setState({ isMapShow: !this.state.isMapShow })
                      }
                    >
                      <FontAwesomeIcon icon="map" size="sm" color="#fff" />
                    </button>
                  </div>
                )
              }
            />
          </div>

          {this.state.isUserAdmin && (
            <div className="d-flex justify-content-center">
              <button
                type="button"
                className="btn btn-secondary btn-with-link mt-3"
              >
                <a href="#confirmRunImportModal" data-toggle="modal">
                  Импорт данных из АСД
                </a>
              </button>
            </div>
          )}
        </div>
        {/* <div className="ml-4 d-none d-md-inline d-lg-inline d-xl-inline"> */}
        <div
          className={
            this.state.isMapShow && !utils.getIsViewportEqual('xs', 'sm')
              ? 'ml-4'
              : 'd-none'
          }
        >
          <RegistryMap
            mapSettings={{ center: [57.15, 65.53], zoom: 9 }}
            markers={this.state.checkpointMarks}
            updateInd={this.state.markersUpdateInd}
            selectedId={this.state.selectedObjectId}
          />
        </div>
        <ConfirmActionModal
          name="confirmRunImportModal"
          onConfirm={this.handleConfirmRunImportAction}
        />
        <ConfirmActionModal
          name="confirmActionModal"
          onConfirm={this.handleConfirmDeleteAction}
        />
      </div>
    );
  }
}

export default CheckpointPage;
